export default "__VITE_ASSET__Cu9wSm2e__"